import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import toastr from "toastr";
import { Formik } from "formik";
import * as Yup from "yup";

import CustomNavbar from "../../components/CustomNavbar";

import messages from "../../redux/messages";

import SidebarDashboard from "../../components/SidebarDashboard";
import { getNineBoxes } from "../../redux/capacitacionDesarrollo/NineBoxes/actions";
import Multiselect from "../../components/Clima/Multiselect";
import NineBoxesPDF from "../../components/capacitacionDesarrollo/NineBoxesPDF";
import { getDivision } from "../../redux/division/actions";
import { getOrgs } from "../../redux/organization/actions";
import { getAreasJerarquia } from "../../redux/areasfuncional/actions";
import { useHistory } from "react-router-dom";
import ReactChipInput from "react-chip-input";

import userperfil from "../../images/userperfil.png";

import "../../css/capacitacion.css";

const NineBoxes = (props) => {
  const fecha = new Date();
  var anioActual = fecha.getFullYear();

  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [colabs, setColabs] = useState([]);
  const [show, setShow] = useState(false);
  const [_orgs, setOrgs] = useState([]);
  const [_orgsId, setOrgsId] = useState("");
  const [_orgsName, setOrgsName] = useState("");
  const [validOrgs, setValidOrgs] = useState(true);
  const [submitOrgs, setSubmitOrgs] = useState(false);
  const [_division, setDivision] = useState([]);
  const [_divisionId, setDivisionId] = useState("");
  const [_divisionName, setDivisionName] = useState("");
  const [validDivision, setValidDivision] = useState(true);
  const [submitDivision, setSubmitDivision] = useState(false);
  const [_areas, setAreas] = useState([]);
  const [_areasId, setAreasId] = useState("");
  const [_areasName, setAreasName] = useState("");
  const [validAreas, setValidAreas] = useState(true);
  const [submitAreas, setSubmitAreas] = useState(false);
  const [chips, setChips] = useState([]);
  const [anioSelected, setAnioSelected] = useState(anioActual);
  const [loadingPrint, setLoadingPrint] = useState(false);
  const [employeeSelected, setEmployeeSelected] = useState(null);
  const [fechaInicio, setFechaInicio] = useState(`${anioActual}-01-01`);
  const [fechaFin, setFechaFin] = useState(`${anioActual}-12-31`);

  const schema = Yup.object().shape({
    anio: Yup.number().when("anioSelected", {
      is: () => anioSelected.toString().length !== 4,
      then: Yup.number().required("**Debe ingresar un numero de 4 digitos"),
    }),
    filtro_fecha: Yup.boolean().notRequired(""),
    fecha_inicio: Yup.string()
      .ensure()
      .when("filtro_fecha", {
        is: true,
        then: Yup.string().required("**Campo requerido"),
      }),
    fecha_fin: Yup.string()
      .ensure()
      .when("filtro_fecha", {
        is: true,
        then: Yup.string().required("**Campo requerido"),
      }),
  });

  const dispatch = useDispatch();
  const history = useHistory();

  const userRoles = useSelector((store) => store.auth.userRoles);
  const userN = useSelector((store) => store.auth.name);

  const {
    loaderNineBoxes,
    nineBoxes,
    potencial_promedio,
    desempenio_promedio,
    employees,
    divisions,
    nineBoxesFalla,
    nineBoxesFormError,
  } = useSelector((store) => store.nineBoxes);

  const { division } = useSelector((store) => store.division);
  const divisionLoading = useSelector((store) => store.division.loading);

  const areas = useSelector((store) => store.areas.areas);
  const loadingAreas = useSelector((store) => store.areas.loading);

  const data = useSelector((store) => store.orgs.orgs);
  const loadingOrgs = useSelector((store) => store.orgs.loading);

  var listOrgs = [];

  // eslint-disable-next-line array-callback-return
  data.map((item) => {
    listOrgs = [
      ...listOrgs,
      { value: item.id, label: item.nombre.toUpperCase() },
    ];
  });

  let listDivision = [];

  // eslint-disable-next-line array-callback-return
  division.map((task) => {
    listDivision = [
      ...listDivision,
      {
        value: task.id,
        label: task.descripcion,
      },
    ];
  });

  var listAreas = [];

  areas
    .filter((e) => e.codigo && e.nombre)
    // eslint-disable-next-line array-callback-return
    .map((item) => {
      listAreas = [
        ...listAreas,
        {
          value: item.id,
          nombre: item.nombre.toUpperCase(),
          codigo: item.codigo,
          label: `${item.codigo ? item.codigo : ""} / ${
            item.nombre ? item.nombre.toUpperCase() : ""
          }`,
        },
      ];
    });

  // Métodos
  const _getNineBoxes = (
    filt = filter,
    orgas = _orgsId,
    division = _divisionId,
    areas = _areasId,
    _ani = anioSelected,
    _ini = fechaInicio,
    _fin = fechaFin
  ) =>
    dispatch(
      getNineBoxes({
        colaborador: filt,
        empresa: orgas,
        departamento: division,
        unidad: areas,
        anio:
          userRoles.includes("administrador") ||
          userRoles.includes("Responsable_Capacitacion")
            ? _ani
            : anioActual,
        fecha_inicio: _ini,
        fecha_fin: _fin,
      })
    );

  useEffect(() => {
    dispatch(getDivision({}));
    dispatch(getOrgs(parseInt(2)));
    dispatch(getAreasJerarquia({}, 2, true));
    // dispatch(getMatrixNineBoxes({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      userRoles.length > 0 &&
      !(
        userRoles.includes("administrador") ||
        userRoles.includes("Responsable_Capacitacion")
      )
    ) {
      _getNineBoxes();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userRoles]);

  // useEffect(() => {
  //   _getNineBoxes();
  // }, [anioSelected]);

  useEffect(() => {
    if (showModal) {
      document.getElementsByName("chipInput")[0].placeholder = "Empleado";
    }
  }, [showModal]);

  const onOpenSearch = () => {
    setFechaInicio(null);
    setFechaFin(null);
    setAnioSelected(anioActual);
    setChips([]);
    setValidOrgs(true);
    setSubmitOrgs(false);
    setOrgs([]);
    setValidDivision(true);
    setSubmitDivision(false);
    setDivision([]);
    setValidAreas(true);
    setSubmitAreas(false);
    setAreas([]);
    setShowModal(true);
  };

  useEffect(() => {
    if (
      userRoles.length > 0 &&
      (userRoles.includes("administrador") ||
        userRoles.includes("Responsable_Capacitacion"))
    ) {
      onOpenSearch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userRoles]);

  const onSearchForm = async (req) => {
    let idOrg = "";
    // eslint-disable-next-line array-callback-return
    _orgs.map((item, index) => {
      if (parseInt(index) === 0) {
        idOrg += `[${item.value}`;
      } else {
        idOrg += `${item.value}`;
      }
      if (!_orgs[parseInt(index) + 1]) {
        idOrg += `]`;
      } else {
        idOrg += `,`;
      }
    });
    setOrgsId(idOrg);
    let nameOrg = [];
    // eslint-disable-next-line array-callback-return
    _orgs.map((item, index) => {
      nameOrg.push(item.label);
    });
    setOrgsName(nameOrg);
    let idDiv = "";
    // eslint-disable-next-line array-callback-return
    _division.map((item, index) => {
      if (parseInt(index) === 0) {
        idDiv += `[${item.value}`;
      } else {
        idDiv += `${item.value}`;
      }
      if (!_division[parseInt(index) + 1]) {
        idDiv += `]`;
      } else {
        idDiv += `,`;
      }
    });
    setDivisionId(idDiv);
    let nameDiv = [];
    // eslint-disable-next-line array-callback-return
    _division.map((item) => {
      nameDiv.push(item.label);
    });
    setDivisionName(nameDiv);
    let idArea = "";
    // eslint-disable-next-line array-callback-return
    _areas.map((item, index) => {
      if (parseInt(index) === 0) {
        idArea += `[${item.value}`;
      } else {
        idArea += `${item.value}`;
      }
      if (!_areas[parseInt(index) + 1]) {
        idArea += `]`;
      } else {
        idArea += `,`;
      }
    });
    let nameArea = [];
    // eslint-disable-next-line array-callback-return
    _areas.map((item, index) => {
      nameArea.push(item.label);
    });
    let idChips = "";
    // eslint-disable-next-line array-callback-return
    chips.map((item, index) => {
      if (parseInt(index) === 0) {
        idChips += `["${item}"`;
      } else {
        idChips += `"${item}"`;
      }
      if (!chips[parseInt(index) + 1]) {
        idChips += `]`;
      } else {
        idChips += `,`;
      }
    });
    setAreasId(idArea);
    setAreasName(nameArea);
    setFilter(idChips);
    setColabs(chips);
    setEmployeeSelected(null);
    let _fecha_inicio = null;
    let _fecha_fin = null;
    if (req.filtro_fecha) {
      _fecha_inicio = req.fecha_inicio;
      _fecha_fin = req.fecha_fin;
    } else {
      _fecha_inicio = `${anioSelected}-01-01`;
      _fecha_fin = `${anioSelected}-12-31`;
    }
    setFechaInicio(_fecha_inicio);
    setFechaFin(_fecha_fin);
    _getNineBoxes(
      idChips,
      idOrg,
      idDiv,
      idArea,
      anioSelected,
      _fecha_inicio,
      _fecha_fin
    );
    setShowModal(false);
  };

  const htmlToImg = async () => {
    try {
      setLoadingPrint(true);
      const input = document.getElementById("impresion1");
      html2canvas(input).then((canvas) => {
        let imgWidth = 200;
        let imgHeight = (canvas.height * imgWidth) / canvas.width;
        // const pdf = new jsPDF("p", "mm", [215, 354]);
        let pdf = jsPDF("p", "mm", "a4");
        pdf.addImage(canvas, "PNG", 5, 5, imgWidth, imgHeight);
        const input2 = document.getElementById("impresion2");
        html2canvas(input2).then((canvas2) => {
          let imgWidth2 = 200;
          let imgHeight2 = (canvas2.height * imgWidth) / canvas2.width;
          pdf.addPage();
          pdf.addImage(canvas2, "PNG", 5, 5, imgWidth2, imgHeight2);
          const input3 = document.getElementById("impresion3");
          html2canvas(input3).then((canvas3) => {
            let imgWidth3 = 200;
            let imgHeight3 = (canvas3.height * imgWidth) / canvas3.width;
            pdf.addPage();
            pdf.addImage(canvas3, "PNG", 5, 5, imgWidth3, imgHeight3);
            pdf.save("matriz_nueve_cajas.pdf");
            setLoadingPrint(false);
          });
        });
      });
    } catch (error) {
      console.log(error);
      document.getElementById("prueba").style.display = "none";
      setLoadingPrint(false);
    }
  };

  const renderSwitch = (param) => {
    switch (param.type) {
      case "paragraph":
        return (
          <p
            style={{
              textAlign: `${param.data.alignment}`,
            }}
            dangerouslySetInnerHTML={{ __html: param.data.text }}
          />
        );
      case "header":
        switch (param.data.level) {
          case 1:
            return (
              <h1
                style={{
                  textAlign: `${param.tunes.anyTuneName.alignment}`,
                }}
                dangerouslySetInnerHTML={{ __html: param.data.text }}
              />
            );
          case 2:
            return (
              <h2
                style={{
                  textAlign: `${param.tunes.anyTuneName.alignment}`,
                }}
                dangerouslySetInnerHTML={{ __html: param.data.text }}
              />
            );
          case 3:
            return (
              <h3
                style={{
                  textAlign: `${param.tunes.anyTuneName.alignment}`,
                }}
                dangerouslySetInnerHTML={{ __html: param.data.text }}
              />
            );
          case 4:
            return (
              <h4
                style={{
                  textAlign: `${param.tunes.anyTuneName.alignment}`,
                }}
                dangerouslySetInnerHTML={{ __html: param.data.text }}
              />
            );
          case 5:
            return (
              <h5
                style={{
                  textAlign: `${param.tunes.anyTuneName.alignment}`,
                }}
                dangerouslySetInnerHTML={{ __html: param.data.text }}
              />
            );
          case 6:
            return (
              <h6
                style={{
                  textAlign: `${param.tunes.anyTuneName.alignment}`,
                }}
                dangerouslySetInnerHTML={{ __html: param.data.text }}
              />
            );
          default:
            return null;
        }
      case "breakLine":
        return <br />;
      default:
        return null;
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <Col
              xs="auto"
              className="d-flex flex-wrap justify-content-start align-items-center"
            >
              <Row className="d-flex flex-wrap justify-content-start align-items-center">
                <div
                  style={{
                    width: "520px",
                  }}
                >
                  <h6 className="text-uppercase">
                    <b>Matriz de 9 cajas</b>
                  </h6>
                </div>
              </Row>
            </Col>

            <Row className="justify-content-sm-end align-items-center flex-nowrap">
              <Col xs="auto">
                <ButtonGroup>
                  {userRoles.length > 0 &&
                    (userRoles.includes("administrador") ||
                      userRoles.includes("Responsable_Capacitacion") ||
                      userRoles.includes("alta_direccion") ||
                      userRoles.includes("jefe")) && (
                      <>
                        <Button
                          id="printId3"
                          variant="warning"
                          size="sm"
                          className="rounded-pill"
                          onClick={() => {
                            htmlToImg();
                          }}
                          disabled={
                            loadingPrint ||
                            loaderNineBoxes ||
                            !nineBoxes ||
                            nineBoxes.count === 0
                          }
                        >
                          {loadingPrint || loaderNineBoxes ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                                size="sm"
                              />
                            </div>
                          ) : (
                            <b>Descargar</b>
                          )}
                        </Button>
                        {/* <NineBoxesPDF nineBoxes={nineBoxes} /> */}
                        <Button
                          id="printId3"
                          variant="primary"
                          size="sm"
                          className="mx-2 rounded-pill"
                          onClick={() =>
                            history.push(
                              `/evaluacion-desempenio/monitor-de-colaboradores`
                            )
                          }
                        >
                          <b>Competencias</b>
                        </Button>
                        <OverlayTrigger
                          placement="auto"
                          overlay={
                            <Tooltip {...props}>Búsqueda avanzada</Tooltip>
                          }
                        >
                          <Button
                            variant="light"
                            size="sm"
                            className="rounded-circle"
                            onClick={() => onOpenSearch()}
                          >
                            <i className="material-icons">search</i>
                          </Button>
                        </OverlayTrigger>
                      </>
                    )}
                </ButtonGroup>
              </Col>
            </Row>
          </div>
          <div className="px-2">
            <hr />
          </div>
          {loaderNineBoxes ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : nineBoxes && nineBoxes.data && !nineBoxesFalla ? (
            <>
              <Col>
                <Row>
                  <Col md="9" className="my-3 mx-auto">
                    <Row>
                      <div
                        className="mb-5 pr-0 d-flex flex-wrap justify-content-center align-items-center text-justify"
                        xs="auto"
                        style={{ width: "20px" }}
                      >
                        <div id="mark">
                          <b>Potencial</b>
                        </div>
                      </div>
                      <Col>
                        <Row className="mx-0">
                          {nineBoxes.data
                            .sort((a, b) =>
                              a.orden > b.orden ? 1 : b.orden > a.orden ? -1 : 0
                            )
                            .map((item, index) => (
                              <>
                                <Col
                                  md="4"
                                  xs="auto"
                                  className="mb-3 d-flex px-0 mx-auto"
                                >
                                  <Card
                                    // className="mb-3 px-0 border border-muted rounded shadow-sm bg-white"
                                    className="mb-3 border border-white px-0 bg-white w-100 h-100"
                                    // style={{ border: "1px solid #ced4da" }}
                                  >
                                    <Card.Header
                                      className={`${
                                        index === 0 ||
                                        index === 4 ||
                                        index === 8
                                          ? "bg-warning"
                                          : index === 1 || index === 5
                                          ? "bg-success"
                                          : index === 2
                                          ? "bg-info"
                                          : index === 6
                                          ? "bg-danger"
                                          : "colorMedio"
                                      } font-weight-bold d-flex flex-wrap justify-content-justify align-items-center text-light`}
                                    >
                                      <p>{item.encabezado_cuadrante}</p>
                                    </Card.Header>
                                    <Card.Body className="py-3 px-4 flex-wrap justify-content-between align-items-between">
                                      {item.empleados.map((_item) => (
                                        <div
                                          className={`buttonEmp rounded ${
                                            employeeSelected &&
                                            employeeSelected.emp.id === _item.id
                                              ? "buttonEmpSelected"
                                              : ""
                                          }`}
                                          onClick={() => {
                                            setEmployeeSelected({
                                              eval: item,
                                              emp: _item,
                                            });
                                          }}
                                        >
                                          <Row className="px-2 d-flex flex-wrap justify-content-justify align-items-center">
                                            <Col md={3}>
                                              <img
                                                src={
                                                  _item.foto
                                                    ? `${process.env.REACT_APP_URL}/media/${_item.foto}`
                                                    : userperfil
                                                }
                                                style={{ width: "100%" }}
                                                className="rounded shadow"
                                                alt="User perfil"
                                              />
                                            </Col>
                                            <Col md={9} className="py-3">
                                              <h6 className="font-weight-bold text-uppercase">
                                                {_item.nombre}
                                              </h6>
                                              <p className="text-uppercase ">
                                                {_item.Funcion_List &&
                                                  _item.Funcion_List.length >
                                                    0 &&
                                                  _item.Funcion_List[0]
                                                    .descripcion}
                                              </p>
                                            </Col>
                                          </Row>
                                          <hr className="m-0" />
                                        </div>
                                      ))}
                                    </Card.Body>
                                  </Card>
                                </Col>
                              </>
                            ))}
                        </Row>
                        <Col
                          className="py-3 d-flex flex-wrap justify-content-center align-items-center text-justify"
                          xs="auto"
                        >
                          <b>Desempeño</b>
                        </Col>
                      </Col>
                    </Row>
                  </Col>
                  <Col md="3" className="mx-auto">
                    <Row className="px-3 mx-0">
                      <Col className="shadow-sm py-2 rounded bg-primary text-light mx-auto">
                        <b>
                          <i className="material-icons">arrow_right</i>
                          {employeeSelected
                            ? `${employeeSelected.emp.codigo}/${employeeSelected.emp.nombre}`
                            : null}
                        </b>
                      </Col>
                    </Row>
                    <Row className="px-3 mx-0">
                      <Col className="shadow-sm my-2 py-2 rounded bg-info text-light mx-auto d-flex flex-wrap justify-content-between align-items-center">
                        <b>
                          <i className="material-icons">arrow_right</i>Potencial
                        </b>
                        <b>
                          {employeeSelected
                            ? `${employeeSelected.emp.potencial}%`
                            : null}
                        </b>
                      </Col>
                    </Row>
                    <Row className="px-3 mx-0">
                      <Col className="shadow-sm mb-2 py-2 rounded bg-success text-light mx-auto d-flex flex-wrap justify-content-between align-items-center">
                        <b>
                          <i className="material-icons">arrow_right</i>Desempeño
                        </b>
                        <b>
                          {employeeSelected
                            ? `${employeeSelected.emp.desempenio_percibido}%`
                            : null}
                        </b>
                      </Col>
                    </Row>
                    <Row className="mx-0">
                      <Col className="mx-auto">
                        <Card
                          className="mb-3 px-0 border border-muted rounded shadow-sm bg-white shadow-sm"
                          style={{ border: "1px solid #ced4da" }}
                        >
                          <Card.Header className="bg-primary text-light d-flex flex-wrap justify-content-between align-items-center">
                            <p>
                              <b>
                                {employeeSelected
                                  ? `${employeeSelected.eval.encabezado_cuadrante}`
                                  : null}
                              </b>
                            </p>
                          </Card.Header>
                          <Card.Body className="py-3 px-4 flex-wrap justify-content-between align-items-between text-justify">
                            {employeeSelected ? (
                              <div
                              // className="border bg-white p-1 rounded"
                              // style={{ width: "230px" }}
                              >
                                {employeeSelected.eval.descripcion_cuadrante.map(
                                  (item) => renderSwitch(item)
                                )}
                              </div>
                            ) : null}
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </>
          ) : (
            <>
              {!!nineBoxesFalla ? (
                <Alert variant="danger" className="mt-4 mb-1 mx-2">
                  {nineBoxesFalla}
                </Alert>
              ) : (
                <Alert variant="info" className="mt-4 mb-1 mx-2">
                  Ingrese el filtro a realizar
                </Alert>
              )}
            </>
          )}
        </Container>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Formik
          validationSchema={schema}
          initialValues={{
            filtro_fecha: false,
            fecha_inicio: `${anioActual}-01-01`,
            fecha_fin: `${anioActual}-12-31`,
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            values,
            touched,
            handleBlur,
            errors,
          }) => (
            <div>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  Búsqueda avanzada
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!nineBoxesFormError && (
                  <Alert variant="danger" className="my-1">
                    {nineBoxesFormError}
                  </Alert>
                )}
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Año:
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      id="anio"
                      name="anio"
                      isInvalid={touched.anio && errors.anio}
                      isValid={touched.anio && !errors.anio}
                      onBlur={handleBlur("anio")}
                      onChange={(e) => {
                        e.preventDefault();
                        setAnioSelected(parseInt(e.currentTarget.value));
                        if (e.currentTarget.value.toString().length === 4) {
                          setFieldValue(
                            "fecha_inicio",
                            `${parseInt(e.currentTarget.value)}-${moment(
                              values.fecha_inicio
                            ).format("MM")}-${moment(
                              values.fecha_inicio
                            ).format("DD")}`
                          );
                          setFieldValue(
                            "fecha_fin",
                            `${parseInt(e.currentTarget.value)}-${moment(
                              values.fecha_fin
                            ).format("MM")}-${moment(values.fecha_fin).format(
                              "DD"
                            )}`
                          );
                        }
                      }}
                      value={anioSelected}
                      className="rounded-pill"
                      type="number"
                      placeholder={`${anioActual}`}
                      size="20"
                      maxlength="4"
                      disabled={values.filtro_fecha}
                    ></Form.Control>
                    {touched.anio && !!errors.anio && (
                      <Col>
                        <small className="text-danger">{errors.anio}</small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Filtro por fecha:
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Check
                      id="filtro_fecha"
                      name="filtro_fecha"
                      isInvalid={touched.filtro_fecha && errors.filtro_fecha}
                      isValid={touched.filtro_fecha && !errors.filtro_fecha}
                      onBlur={handleBlur("filtro_fecha")}
                      onChange={(e) => {
                        setFieldValue("filtro_fecha", e.target.checked);
                      }}
                      value={values.filtro_fecha}
                      className="rounded-pill"
                      type="switch"
                      defaultChecked={false}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Fecha inicio:
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      id="fecha_inicio"
                      name="fecha_inicio"
                      isInvalid={
                        (touched.fecha_inicio && errors.fecha_inicio) ||
                        (touched.fecha_inicio &&
                          values.fecha_inicio !== "" &&
                          values.fecha_fin !== "" &&
                          moment(values.fecha_inicio) >
                            moment(values.fecha_fin))
                      }
                      isValid={
                        (touched.fecha_inicio && !errors.fecha_inicio) ||
                        (touched.fecha_inicio &&
                          !(
                            values.fecha_inicio !== "" &&
                            values.fecha_fin !== "" &&
                            moment(values.fecha_inicio) >
                              moment(values.fecha_fin)
                          ))
                      }
                      onBlur={handleBlur("fecha_inicio")}
                      onChange={(e) => {
                        e.preventDefault();
                        handleChange(e);
                        setFechaInicio(
                          moment(e.currentTarget.value).format("YYYY-MM-DD")
                        );
                      }}
                      value={values.fecha_inicio}
                      type="date"
                      className="rounded-pill"
                      disabled={!values.filtro_fecha}
                    />
                    {touched.fecha_inicio && !!errors.fecha_inicio && (
                      <div className="px-2">
                        <small className="text-danger">
                          {errors.fecha_inicio}
                        </small>
                      </div>
                    )}
                    {values.fecha_inicio !== "" &&
                      values.fecha_fin !== "" &&
                      moment(values.fecha_inicio) >
                        moment(values.fecha_fin) && (
                        <div className="px-2">
                          <small className="text-danger">
                            **La fecha inicio no pueder ser mayor a la fecha fin
                          </small>
                        </div>
                      )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Fecha fin:
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      id="fecha_fin"
                      name="fecha_fin"
                      isInvalid={
                        (touched.fecha_fin && errors.fecha_fin) ||
                        (touched.fecha_fin &&
                          values.fecha_fin !== "" &&
                          values.fecha_fin !== "" &&
                          moment(values.fecha_fin) > moment(values.fecha_fin))
                      }
                      isValid={
                        (touched.fecha_fin && !errors.fecha_fin) ||
                        (touched.fecha_fin &&
                          !(
                            values.fecha_fin !== "" &&
                            values.fecha_fin !== "" &&
                            moment(values.fecha_fin) > moment(values.fecha_fin)
                          ))
                      }
                      onBlur={handleBlur("fecha_fin")}
                      onChange={(e) => {
                        e.preventDefault();
                        handleChange(e);
                        setFechaFin(
                          moment(e.currentTarget.value).format("YYYY-MM-DD")
                        );
                      }}
                      value={values.fecha_fin}
                      type="date"
                      className="rounded-pill"
                      disabled={!values.filtro_fecha}
                    />
                    {touched.fecha_fin && !!errors.fecha_fin && (
                      <div className="px-2">
                        <small className="text-danger">
                          {errors.fecha_fin}
                        </small>
                      </div>
                    )}
                    {values.fecha_fin !== "" &&
                      values.fecha_fin !== "" &&
                      moment(values.fecha_fin) > moment(values.fecha_fin) && (
                        <div className="px-2">
                          <small className="text-danger">
                            **La fecha inicio no pueder ser mayor a la fecha fin
                          </small>
                        </div>
                      )}
                  </Col>
                </Form.Group>
                {userRoles.length > 0 &&
                (userRoles.includes("administrador") ||
                  userRoles.includes("Responsable_Capacitacion")) ? (
                  <>
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        Empresa:
                      </Form.Label>
                      <Col sm={9}>
                        <Row className="d-flex flex-wrap align-items-center">
                          <Col sm={loadingOrgs ? "10" : "12"}>
                            <Multiselect
                              options={listOrgs}
                              value={_orgs}
                              onChange={setOrgs}
                              isValid={validOrgs}
                              isDisabled={loadingOrgs}
                              isSubmit={submitOrgs}
                            />
                          </Col>
                          {loadingOrgs && (
                            <Col sm={1}>
                              <Spinner animation="border" size="sm" />
                            </Col>
                          )}
                        </Row>
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row}>
                      <Form.Label column sm={3}>
                        División:
                      </Form.Label>
                      <Col sm={9}>
                        <Row className="d-flex flex-wrap align-items-center">
                          <Col sm={divisionLoading ? "10" : "12"}>
                            <Multiselect
                              options={listDivision}
                              value={_division}
                              onChange={setDivision}
                              isValid={validDivision}
                              isDisabled={divisionLoading}
                              isSubmit={submitDivision}
                            />
                          </Col>
                          {divisionLoading && (
                            <Col sm={1}>
                              <Spinner animation="border" size="sm" />
                            </Col>
                          )}
                        </Row>
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-md-0">
                      <Form.Label column sm={3}>
                        Unidad organizativa:
                      </Form.Label>
                      <Col sm={9}>
                        <Row className="d-flex flex-wrap align-items-center">
                          <Col sm={loadingAreas ? "10" : "12"}>
                            <Multiselect
                              options={listAreas}
                              value={_areas}
                              onChange={setAreas}
                              isValid={validAreas}
                              isDisabled={loadingAreas}
                              isSubmit={submitAreas}
                            />
                          </Col>
                          {loadingAreas && (
                            <Col sm={1}>
                              <Spinner animation="border" size="sm" />
                            </Col>
                          )}
                        </Row>
                      </Col>
                    </Form.Group>
                  </>
                ) : null}
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Empleado:
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={12}>
                        <ReactChipInput
                          chips={chips}
                          placeholder="Código o nombre del empleado"
                          onSubmit={(value) => {
                            const _chips = chips.slice();
                            _chips.push(value);
                            setChips(_chips);
                          }}
                          onRemove={(index) => {
                            const _chips = chips.slice();
                            _chips.splice(index, 1);
                            setChips(_chips);
                          }}
                        />
                      </Col>
                    </Row>
                    <div>
                      <small className="text-muted mx-1">
                        <b>Búsqueda por: Código o nombre de empleado</b>
                        {/* <b>Búsqueda por: Código de empleado</b> */}
                      </small>
                    </div>
                    <div>
                      <small className="text-muted mx-1">
                        <b>
                          (Para agregar los elementos a la lista, presione la
                          tecla "Enter")
                        </b>
                      </small>
                    </div>
                  </Col>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={
                    (loaderNineBoxes ||
                      loadingOrgs ||
                      divisionLoading ||
                      loadingAreas) &&
                    userRoles.length > 0 &&
                    (userRoles.includes("administrador") ||
                      userRoles.includes("Responsable_Capacitacion"))
                  }
                  variant="primary"
                  type="button"
                  onClick={(e) => {
                    if (!errors.anio) {
                      onSearchForm({
                        fecha_inicio:
                          document.getElementById("fecha_inicio").value,
                        fecha_fin: document.getElementById("fecha_fin").value,
                        filtro_fecha:
                          document.getElementById("filtro_fecha").value ===
                          "true",
                      });
                    } else {
                      toastr.error(messages.validYear, "", {
                        progressBar: true,
                        rtl: true,
                      });
                    }
                  }}
                >
                  {(loaderNineBoxes ||
                    loadingOrgs ||
                    divisionLoading ||
                    loadingAreas) &&
                  userRoles.length > 0 &&
                  (userRoles.includes("administrador") ||
                    userRoles.includes("Responsable_Capacitacion")) ? (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : null}
                  Buscar
                </Button>
              </Modal.Footer>
            </div>
          )}
        </Formik>
      </Modal>
      <NineBoxesPDF
        nineBoxes={nineBoxes}
        solicitador={userN}
        areas={_areasName}
        division={_divisionName}
        emps={_orgsName}
        colaboradores={colabs}
        fecha={moment().format("DD/MM/YYYY")}
        potencial_promedio={potencial_promedio}
        desempenio_promedio={desempenio_promedio}
        employees={employees}
        divisions={divisions}
      />
    </>
  );
};

export default NineBoxes;
